'use client';

import { Button } from '@common/components';
import SvgChevrondown from '@common/icon/SvgChevrondown';
import { cn } from '@core/utils';
import type { ReactNode } from 'react';
import { useState } from 'react';

export const GiftPreviewToggle = ({ children }: { children: ReactNode }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="relative">
      <div className={cn(!isExpanded && 'max-h-[1400px] overflow-hidden')}>
        {children}
      </div>
      {isExpanded ? null : (
        <div className="absolute inset-x-0 bottom-0 flex h-140 items-end bg-gradient-to-t from-Gray-white from-40% to-transparent px-20 pb-24">
          <Button
            theme="sub-line"
            dimensions="H48"
            className="w-full"
            aria-expanded={false}
            onClick={() => setIsExpanded(true)}
          >
            상품정보 더보기
            <SvgChevrondown aria-hidden className="size-16 text-Gray-600" />
          </Button>
        </div>
      )}
    </div>
  );
};
